import { motion } from "framer-motion";

const FACTORY_IMG = "https://images.unsplash.com/photo-1655122878062-a9e885391a1b?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function About({ about }) {
  return (
    <section id="about" className="bg-[#161B22]/50 border-y border-white/5" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="rounded-3xl overflow-hidden border border-white/10 aspect-[4/3]">
          <img src={FACTORY_IMG} alt="AZ Concepts textile production hall" loading="lazy" className="w-full h-full object-cover" />
        </motion.div>
        <div>
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]" data-testid="about-eyebrow">Who We Are</p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="about-heading">{about.title}</h2>
          <p className="mt-6 text-base md:text-lg text-slate-400 leading-relaxed" data-testid="about-text">{about.text}</p>
        </div>
      </div>
    </section>
  );
}
